import { render } from "./CustomSchoolYearSelectDatePicker.vue?vue&type=template&id=4f23ce66"
import script from "./CustomSchoolYearSelectDatePicker.vue?vue&type=script&lang=js"
export * from "./CustomSchoolYearSelectDatePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__